import { useTranslation } from 'react-i18next';
import AccountCard from '@/components/settings/AccountCard';
import ChangePasswordCard from '@/components/settings/ChangePasswordCard';
import LanguageSwitch from '@/components/LanguageSwitch';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export default function SettingsPage() {
  const { t } = useTranslation('settings');
  return (
    <div className="flex flex-col gap-4">
      <h2 className="text-2xl font-semibold">{t('title')}</h2>
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <AccountCard />
        <Card>
          <CardHeader>
            <CardTitle>{t('language.title')}</CardTitle>
          </CardHeader>
          <CardContent>
            <LanguageSwitch />
          </CardContent>
        </Card>
      </div>
      <ChangePasswordCard />
    </div>
  );
}
